import React from "react"
import slugify from "slugify"
import clsx from "clsx"

import { Asset, RichText } from "components"

function Collage({ collageText, content, images }) {
  // extract ID from content, if relevant
  let id = ""
  if (content?.raw) {
    let contentParsed = JSON.parse(content.raw)
    if (
      contentParsed?.content &&
      contentParsed?.content[0]?.nodeType?.startsWith("heading")
    ) {
      id = contentParsed?.content[0]?.content[0]?.value
    }
  }

  return (
    <section
      data-slice="Collage"
      id={slugify(id)}
      className="relative pt-24 wrapper default-grid md:pt-30 gap-y-10 md:gap-y-14"
    >
      {content && (
        <RichText
          className="md:col-start-2 md:col-span-10 col-span-full"
          content={content}
          size="large"
        />
      )}
      <div className="mx-0 collage-grid md:-mx-fluidMargin xl:-mx-26 col-span-full">
        {images?.map((image, i) => (
          <div
            className={clsx(i >= 12 && "hidden md:block", i > 17 && "hidden")}
            style={{ gridArea: "I" + i }}
            key={`collageItem--${i}`}
          >
            <div className="select-none">
              <Asset asset={image} style={{ display: "block" }} />
            </div>
          </div>
        ))}
        <div
          className="flex items-center justify-center py-4 text-center sm:py-6 md:py-0 md:px-14 text-violet"
          style={{ gridArea: "x" }}
        >
          {collageText && (
            <>
              <p className="hidden md:block h2">{collageText}</p>
              <p className="block md:hidden h1">{collageText}</p>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default Collage
